var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler.apply(null, arguments)}}},[_c('a',{attrs:{"href":"javascript:;"}},[_c('span',{class:_vm.value ? _vm.icon : (_vm.toggleIcon || _vm.icon)}),_vm._v(" "+_vm._s(_vm.value ? _vm.label : _vm.toggleLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }